module.exports = __webpack_public_path__ + "img/andresaguilar.b8e899b3.jpg";